import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { Button } from 'devextreme-react/button';
import DataGrid, {
  Column,
  Editing,
  FilterRow,
  Form,
  Lookup,
  Pager,
  Paging,
  Popup,
  RequiredRule,
} from 'devextreme-react/data-grid';
import { Item, Label } from 'devextreme-react/form';
import 'devextreme-react/text-area';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import CustomStore from 'devextreme/data/custom_store';
import $createStore from 'utils/create-store-instance';
import { requestHelper } from 'utils/request-helper';

const PostPage: FC = () => {
  const [data, setData] = useState([]);

  const postDataStore: any = new CustomStore({
    key: 'id',
    load: (loadOptions: any) => requestHelper('/v1/Post', 'get', loadOptions),
    insert: async (values) => {
      await requestHelper('/v1/Post', 'post', {
        values: values,
      });
    },

    remove: async (key) =>
      await requestHelper(`/v1/Post/${key}`, 'delete', {
        key: key,
      }),

    update: async (key, values) =>
      await requestHelper(`/v1/Post/${key}`, 'put', {
        key: key,
        values: values,
      }),
  });

  const salaryTypesDataSource = useCallback(async () => {
    const response = await $createStore('/v1/post/salaryTypes', 'id').load();
    setData(response as any);
  }, []);

  useEffect(() => {
    salaryTypesDataSource();
  }, [salaryTypesDataSource]);

  const refGrid = useRef<DataGrid | null>(null);

  return (
    <div className="container-dev">
      <AppLayoutTop title="Должности">
        <Button width={120} text="Создать" type="default" onClick={() => refGrid.current?.instance.addRow()} />
      </AppLayoutTop>

      <AppCard>
        <DataGrid
          dataSource={postDataStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          onRowUpdating={(e) => (e.newData = { ...e.oldData, ...e.newData })}
          onInitNewRow={(e) => (e.data = { name: '', comment: '', salaryType: null })}
        >
          <FilterRow visible={true} />

          <Editing
            mode="popup"
            allowUpdating={true}
            texts={{
              editRow: 'Просмотр',
            }}
            allowDeleting={true}
          >
            <Popup title="Просмотр информации" showTitle={true} width={400} height="auto" />
            <Form>
              <Item itemType="group" colCount={2} colSpan={2}>
                <Item dataField="name" caption="Наименование" colSpan={2}>
                  <RequiredRule message="Заполните поле Наименование" />
                </Item>
                <Item
                  caption="Тип зарплаты"
                  dataField="salaryType"
                  colSpan={2}
                  editorType="dxSelectBox"
                  editorOptions={{
                    dataSource: data,
                    displayExpr: 'name',
                    valueExpr: 'id',
                    searchEnabled: true,
                    placeholder: 'Выберите тип зарплаты',
                  }}
                >
                  <Label text="Правило начисления зарплаты" />
                  <RequiredRule message="Выберите правило начисления зарплаты" />
                </Item>
                <Item dataField="comment" caption="Комментарий" colSpan={2} editorType="dxTextArea"></Item>
                {/* <Item dataField="isDeleted" caption="Удалён" colSpan={1} /> */}
              </Item>
            </Form>
          </Editing>

          <Column dataField="name" caption="Наименование" sortOrder="asc" />
          <Column dataField="salaryType" caption="Правило начисления зарплаты" width={200}>
            <Lookup dataSource={data} valueExpr="id" displayExpr="name" />
          </Column>
          <Column dataField="comment" caption="Комментарий" />
          {/* <Column dataField="isDeleted" caption="Удалён" width={200} /> */}

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default PostPage;
